(() => {
  if (window.preamp.intCtaHasRun) {
    return;
  }

  const bootcampCtaArray = [...document.querySelectorAll('.js-dual-cta-find-bootcamp')];
  const collegeSearchArray = [...document.querySelectorAll('.js-dual-cta-search-colleges')];
  const widgets = bootcampCtaArray.concat(collegeSearchArray);

  if (!widgets.length) return;

  const buildUrl = () => {
    let url = 'https://college.bestcolleges.com/app/experience/';
    // Set degree from contextualDefaults
    if (window?.HE?.contextualDefaults?.degree?.slug) {
      url += `?degree=${window.HE.contextualDefaults.degree.slug}`;
    }

    // Set category from contextualDefaults
    if (window?.HE?.contextualDefaults?.category?.slug) {
      url += `&category=${window.HE.contextualDefaults.category.slug}`;
    }

    // Set subject from contextualDefaults
    if (window?.HE?.contextualDefaults?.subject?.slug) {
      url += `&subject=${window.HE.contextualDefaults.subject.slug}`;
    }
    return url;
  };

  const generateUUID = (n) => {
    return n
      ? (n ^ ((16 * Math.random()) >> (n / 4))).toString(16)
      : ([1e7] + -1e3 + -4e3 + -8e3 + -1e11).replace(/[018]/g, generateUUID);
  };

  widgets.forEach((widget) => {
    const {
      position,
      elementType,
      location,
      htmlId,
      name,
    } = widget.dataset;
    const linkTitle = widget.querySelector('.js-link-title').innerHTML;
    const isStudyMatchCta = position === '2';
    let link = widget.getAttribute('href');

    // if it's the SM button and has set QDF defaults, the link will use those parameters instead
    if (isStudyMatchCta && window?.HE?.contextualDefaults) {
      widget.setAttribute('href', buildUrl());
      link = widget.getAttribute('href');
    }

    const correlationId = generateUUID();

    const elementPayload = {
      position,
      elementType,
      text: linkTitle,
      location,
      htmlId,
      name,
    };

    widget.addEventListener('click', () => {
      window.tagular('beam', 'ElementClicked', {
        '@type': 'redventures.usertracking.v3.ElementClicked',
        webElement: elementPayload,
        outboundUrl: link,
        correlationId,
      });
    });

    let widgetViewed = false;
    if ('IntersectionObserver' in window) {
      const observer = new IntersectionObserver((entries) => {
        if (entries[0].isIntersecting && !widgetViewed) {
          window.tagular('beam', 'ElementViewed', {
            '@type': 'redventures.usertracking.v3.ElementViewed',
            webElement: elementPayload,
          });
          widgetViewed = true;
        }
      }, {
        threshold: 0.5,
      });
      observer.observe(widget);
    }
  });
  window.preamp.intCtaHasRun = true;
})();
